import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import Home from './pages/Home/Home';
import AboutUs from './pages/AboutUs/AboutUs';
import ContactUs from './pages/ContactUs/ContactUs';
import TermsConditions from './pages/TermsConditions/TermsConditions';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import DataPrivacyAccountDetails from './pages/DataPrivacyAccountDetails/DataPrivacyAccountDetails';
import WhyPhoneVue from './pages/WhyPhoneVue/WhyPhoneVue';
import HowPhoneVue from './pages/HowPhoneVue/HowPhoneVue';
import PhoneVueFunctions from './pages/PhoneVueFunctions/PhoneVueFunctions';
import PhoneVueFeatures from './pages/PhoneVueFeatures/PhoneVueFeatures';
import BatteryDegradation from './pages/BatteryDegradation/BatteryDegradation';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/why-phonevue" element={<WhyPhoneVue />} />
            <Route path="/how-phonevue" element={<HowPhoneVue />} />
            <Route path="/phonevue-functions" element={<PhoneVueFunctions />} />
            <Route path="/phonevue-features" element={<PhoneVueFeatures />} />
            <Route path="/battery-degradation" element={<BatteryDegradation />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/data-privacy-account-details" element={<DataPrivacyAccountDetails />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;

